import React from 'react';
import { Typography as RapydTypography } from '@rapyd/react-ui-library';
import { TypographyProps } from '@rapyd/react-ui-library/dist/components/Typography';
import { ThemeBreakpoints } from 'models';

export interface ITypographyProps extends TypographyProps {}

const Typography = ({
  className,
  name,
  type,
  children,
  staticSize = ThemeBreakpoints.LARGE,
  ...rest
}: ITypographyProps) => {
  return (
    <RapydTypography
      className={className}
      name={name || 'typography'}
      type={type}
      staticSize={staticSize}
      {...rest}
    >
      {children}
    </RapydTypography>
  );
};

export default Typography;
